import React, { useState, useImperativeHandle, forwardRef, useEffect } from 'react';
import { Rnd } from "react-rnd";


const WindowsManager = ({ children, setValue }, ref) => {

    const init = children?.length ? children.map((_, idx) => ({
        id: idx,
        open: false,
        position: { x: (window.innerWidth / 2) + (5 * idx), y: 100 + (5 * idx) },
        width: 500,
        height: 'auto',
        zIndex: 10 + idx,
        active: false
    })) : [];


    const [windowsStats, setWindowsStats] = useState(init.reduce((acc, obj) => {
        acc[obj.id] = obj;
        return acc;
    }, {}));


    const getOpenPopupsStats = () => Object.values(windowsStats).filter(w => w.open);
    const openPopup = (id) => {
        bringToFront(id);
        setWindowsStats(p => ({ ...p, [id]: { ...p[id], open: true, active: true } }));
    };
    const closePopup = (id) => setWindowsStats(p => ({ ...p, [id]: { ...p[id], open: false, active: false } }));
    const closeAll = () => {
        setWindowsStats(init.reduce((acc, obj) => {
            acc[obj.id] = obj;
            return acc;
        }, {}));
    };

    const reshapePopups = (layout) => {
        const openWindows = Object.values(windowsStats).filter((w) => w.open);
        const updatedStats = structuredClone(windowsStats);

        openWindows.forEach((wind, i) => {
            let newX = 0;
            let newY = 0;
            if (layout === "grid") {
                const col = i % 2;
                const row = Math.floor(i / 2);
                newX = (window.innerWidth / 2) + 10 + col * (window.innerWidth / 4 - 20);
                newY = 45 + row * 250;
            } else {
                newX = (window.innerWidth / 2) + 50 + i * 30;
                newY = 100 + i * 30;
            }

            updatedStats[wind.id] = {
                ...updatedStats[wind.id],
                position: { x: newX, y: newY },
                height: 200,
                width: 300,
                active: false,
                zIndex: 10,
            };
        });

        setWindowsStats(updatedStats);
    };

    useImperativeHandle(ref, () => ({
        openPopup,
        closePopup,
        closeAll,
        reshapePopups,
        getOpenPopupsStats,

    }));

    const updatePosition = (id, data) => {
        setWindowsStats(p => ({ ...p, [id]: { ...p[id], position: { x: data.x, y: data.y } } }));
    };

    const updateSize = (id, w, h, position) => {
        setWindowsStats(p => ({ ...p, [id]: { ...p[id], position, width: w, height: h } }));
    };

    const bringToFront = (id) => {
        const openWindows = Object.values(windowsStats).filter((w) => w.open);
        const updatedStats = structuredClone(windowsStats);
        openWindows.forEach((wind, i) => {
            updatedStats[wind.id] = {
                ...updatedStats[wind.id],
                zIndex: wind.id === id ? 11 : 10,
                active: wind.id === id,
            };
        });
        setWindowsStats(updatedStats);
    };

    useEffect(() => {
        if (setValue) {
            setValue(windowsStats);
        }
        // eslint-disable-next-line
    }, [windowsStats]);

    if (!children?.length) return null;

    return children?.map((child, index) => {

        const win = windowsStats[index];
        if (!win || !win.open) return null;

        return (
            <Rnd
                key={index}
                position={win.position}
                size={{ width: win.width, height: win.height }}
                onDragStop={(_, d) => updatePosition(index, d)}
                onResizeStop={(e, dir, ref, delta, position) => updateSize(index, ref.offsetWidth, ref.offsetHeight, position)}
                default={{ width: win.width }}
                minWidth={150}
                minHeight={150}
                bounds="body"
                style={{ zIndex: win.zIndex, position: 'absolute' }}
                onMouseDown={() => bringToFront(index)}
                dragHandleClassName="drag-handle"
            >
                {child}
            </Rnd>

        );
    });


};

export default forwardRef(WindowsManager);